import http from "@/services/http";

export async function subscribeMailingList(): Promise<void> {
  if (!globalThis.env.API_PROFILE) {
    return;
  }
  await http().post(`${globalThis.env.API_PROFILE}/subscribe-mailing-list`, {
    CiscoUOptIn: true,
  });
}
